import { Document, Page, View } from '@react-pdf/renderer';
import React from 'react';
import Background from './Background';
import Content from './Content';
import { OrganizationDataOutSchema } from 'src/utils/api.interfaces';
import CreationDate from './CreationDate';
import LogoText from './LogoText';

interface Props {
  organization: OrganizationDataOutSchema;
  topLogoBase64: string;
  bottomLogoBase64: string;
}

export default function PdfDocument(props: Readonly<Props>) {
  const { bottomLogoBase64, topLogoBase64, organization } = props;

  return (
    <Document>
      <Page size="A4" orientation="landscape">
        <View>
          <Background />
          <Content organization={organization} />
          <CreationDate />
          <LogoText
            topLogoBase64={topLogoBase64}
            bottomLogoBase64={bottomLogoBase64}
          />
        </View>
      </Page>
    </Document>
  );
}
